/**
 * Get file extension from result type string.
 */
const getExtensionFromResultType = (resultType: string): string => {
  if (resultType === 'video') return 'mp4';
  if (resultType === 'audio') return 'mp3';
  return 'png';
};

export default getExtensionFromResultType;
